import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Grid, Header, Segment, List, Label } from "semantic-ui-react";
import { GamButtons } from "../utils/buttons";
import { AdServeData } from "../../banner/ad-data";

const Info = ({ retailer }) => {
  const banner = useSelector((state) => state.banner);
  const user = useSelector((state) => state.user);

  const [hideFields, setHideFields] = useState(true);

  useEffect(() => {
    if (retailer === "tesco" || retailer === "tesco_ie") setHideFields(false);
  }, [retailer]);

  return (
    <>
      <Grid padded className="trade-info">
        {user && banner.adServeData && (
          <Grid.Row>
            <Grid.Column computer={16} tablet={16} mobile={16}>
              <AdServeData data={banner.adServeData} />
            </Grid.Column>
          </Grid.Row>
        )}
        <Grid.Row>
          <Grid.Column computer={4} tablet={8} mobile={16}>
            <Header as="h3">Banner info</Header>
            <Segment>
              <List divided celled size="medium">
                <List.Item>
                  <List.Content>
                    <List.Header>Title</List.Header>
                    {banner.bannerTitle}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>Ad number</List.Header>
                    {banner.adNumber}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>Advertiser</List.Header>
                    {banner.advertiser}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>Banner link</List.Header>
                    {banner.bannerURL}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>Tesco event</List.Header>
                    {banner.tescoEvent}
                  </List.Content>
                </List.Item>
              </List>
            </Segment>
          </Grid.Column>
          <Grid.Column computer={4} tablet={8} mobile={16}>
            <Header as="h3">Banner text</Header>
            <Segment>
              <List divided celled size="medium">
                <List.Item>
                  <List.Content>
                    <List.Header>Headline</List.Header>
                    {banner.headline}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>Subhead</List.Header>
                    {banner.subhead}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>Terms</List.Header>
                    {banner.terms}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>Include drinkaware?</List.Header>
                    {banner.drinkaware ? "yes" : "no"}
                  </List.Content>
                </List.Item>
              </List>
            </Segment>
          </Grid.Column>
          <Grid.Column computer={2} tablet={4} mobile={16}>
            <Header as="h3">Panel values</Header>
            <Segment>
              <List divided celled size="medium">
                <List.Item>
                  <List.Content>
                    <List.Header>Background colour</List.Header>
                    {banner.bgColor}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>Font colour</List.Header>
                    {banner.fontColor}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>Panel Colour</List.Header>
                    {banner.panelColor}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>Include panel?</List.Header>
                    {banner.includePanel}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>Hide panel?</List.Header>
                    {banner.hidePanel}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>50/50 split?</List.Header>
                    {banner.fiftyfifty ? "yes" : "no"}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>CTA colour</List.Header>
                    {banner.ctaColor}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>Chevron colour</List.Header>
                    {banner.chevronColor}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>Invert CTA?</List.Header>
                    {banner.invertCta ? "yes" : "no"}
                  </List.Content>
                </List.Item>
              </List>
            </Segment>
          </Grid.Column>
          <Grid.Column computer={2} tablet={4} mobile={16}>
            <Header as="h3">Value tile</Header>
            <Segment>
              <List divided celled size="medium">
                <List.Item>
                  <List.Content>
                    <List.Header>Include VT?</List.Header>
                    {banner.valueTile ? "yes" : "no"}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>No offer tile?</List.Header>
                    {banner.vtWhite ? "yes" : "no"}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>Clubcard price?</List.Header>
                    {banner.clubcardPrice ? "yes" : "no"}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>VT colour</List.Header>
                    {banner.valueTileBackground}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>VT font colour</List.Header>
                    {banner.valueTileColor}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>VT top text</List.Header>
                    {banner.valueTileTop}{" "}
                    <Label>{banner.valueTileTopFont}</Label>
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>Strikethrough?</List.Header>
                    {banner.strikethrough ? "yes" : "no"}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>VT bottom text</List.Header>
                    {banner.valueTileBottom}
                    <sup>{banner.decimalPlace}</sup>
                    {banner.percentSign}{" "}
                    <Label>{banner.valueTileBottomFont}</Label>
                  </List.Content>
                </List.Item>
                {hideFields && (
                  <List.Item>
                    <List.Content>
                      <List.Header>VT currency</List.Header>
                      {banner.vtCurrency}
                    </List.Content>
                  </List.Item>
                )}
                <List.Item>
                  <List.Content>
                    <List.Header>Include asterisk?</List.Header>
                    {banner.includeAsterisk ? "yes" : "no"}{" "}
                    {banner.includeAsterisk && (
                      <Label>{banner.asteriskSize}</Label>
                    )}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>Regular Price</List.Header>
                    {banner.regularPricePrice}{" "}
                    <Label>{banner.regularPriceFontSize}</Label>
                  </List.Content>
                </List.Item>
              </List>
            </Segment>
          </Grid.Column>
          <Grid.Column computer={4} tablet={8} mobile={16}>
            <Header as="h3">Images</Header>
            <Segment>
              <List divided celled size="medium">
                <List.Item>
                  <List.Content>
                    <List.Header>Orientation</List.Header>
                    {banner.orientation}
                  </List.Content>
                </List.Item>
                {banner.primaryPackshot && banner.primaryPackshot.path && (
                  <List.Item>
                    <List.Content>
                      <List.Header>Primary packshot</List.Header>
                      <img
                        src={banner.primaryPackshot.path}
                        alt="primary packshot"
                      />
                    </List.Content>
                  </List.Item>
                )}
                {banner.secondaryPackshot && banner.secondaryPackshot.path && (
                  <List.Item>
                    <List.Content>
                      <List.Header></List.Header>
                      <img
                        src={banner.secondaryPackshot.path}
                        alt="secondary packshot"
                      />
                    </List.Content>
                  </List.Item>
                )}
                {banner.logo && banner.logo.path && (
                  <List.Item>
                    <List.Content>
                      <List.Header>Logo</List.Header>
                      <img src={banner.logo.path} alt="logo" />
                    </List.Content>
                  </List.Item>
                )}
                {banner.background && banner.background.path && (
                  <>
                    <List.Item>
                      <List.Content>
                        <List.Header>Background image</List.Header>
                        <img src={banner.background.path} alt="background" />
                      </List.Content>
                    </List.Item>
                    <List.Item>
                      <List.Content>
                        <List.Header>Background position</List.Header>
                        {banner.backgroundPosition}
                      </List.Content>
                    </List.Item>
                  </>
                )}
                {banner.buylistHeader && banner.buylistHeader.path && (
                  <List.Item>
                    <List.Content>
                      <List.Header>Buylist header</List.Header>
                      <img
                        src={banner.buylistHeader.path}
                        alt="buylist header"
                      />
                    </List.Content>
                  </List.Item>
                )}
              </List>
            </Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      {user && user.isAdOps && <GamButtons banner={banner} service="gam" />}
    </>
  );
};

export default Info;
